import isDisplayMenu from '~/src/lib/isDisplayMenu';

export default function getAvailableMenus(menus, user, lang) {
    const d = menus.filter((o) => {
        //console.log(33333);
        //console.log(o);

        if (['website', 'pdf'].includes(o.type)) {
            if (+o.active === 1) {
                if (isDisplayMenu(o, user, lang) === true) {
                    return true;
                }
            }
        }

        return false;
    });
    return d;
}
